import { httpClient } from '@/modules/common/services/http/http-client';

export function postHomeBrokerToken(customerId: string) {
  return httpClient.post<{ token: string }>(
    `api/v1/trade/customers/${customerId}/generate-hb-token`
  );
}
